import { type TNotification } from '@/models/notification';

import { AnalysisRefusedNotification } from './AnalysisRefusedNotification';
import { ArticleNoneServiceChoiceNotification } from './ArticleNoneServiceChoiceNotification';
import { ArticleQualityControlKONotification } from './ArticleQualityControlKONotification';
import { ArticleRepairIssueReportedNotification } from './ArticleRepairIssueReportedNotification';
import { ArticleRepairStartedNotification } from './ArticleRepairStartedNotification';
import { ArticlesFeedbackSubmittedNotification } from './ArticlesFeedbackSubmittedNotification';
import { ArticleStatusDueAtManuallyUpdatedNotification } from './ArticleStatusDueAtManuallyUpdatedNotification';
import { ClientCommentAddedNotification } from './ClientCommentAddedNotification';
import { CommentAddedNotification } from './CommentAddedNotification';
import { DispatchProposalRefusedNotification } from './DispatchProposalRefusedNotification';
import { DispatchProposalSubmittedNotification } from './DispatchProposalSubmittedNotification';
import { DispatchRefusedNotification } from './DispatchRefusedNotification';
import { DueDateAlertingNotification } from './DueDateAlertingNotification';
import { ExchangeCanceledNotification } from './ExchangeCanceledNotification';
import { ExchangeStockAvailabilityRefusedNotification } from './ExchangeStockAvailabilityRefusedNotification';
import { FinalQuoteRefusedNotification } from './FinalQuoteRefusedNotification';
import { InitialQuoteAcceptedNotification } from './InitialQuoteAcceptedNotification';
import { InitialQuoteRefusedNotification } from './InitialQuoteRefusedNotification';
import { InvoicesToValidateNotification } from './InvoicesToValidateNotification';
import { MissingArticleCustomsNotification } from './MissingArticleCustomsNotification';
import { NewClientFeedbackNotification } from './NewClientFeedbackNotification';
import { NewRequalificationNotification } from './NewRequalificationNotification';
import { NewSupervisorAssignmentBulkNotification } from './NewSupervisorAssignmentBulkNotification';
import { NewSupervisorAssignmentNotification } from './NewSupervisorAssignmentNotification';
import { PendingAnalysisNotification } from './PendingAnalysisNotification';
import { PendingClientContactNotification } from './PendingClientContactNotification';
import { PendingClientPickupNotification } from './PendingClientPickupNotification';
import { PendingDispatchAcceptationNotification } from './PendingDispatchAcceptationNotification';
import { PendingExchangeNotification } from './PendingExchangeNotification';
import { PendingExchangeStockAvailabilityConfirmationNotification } from './PendingExchangeStockAvailabilityConfirmationNotification';
import { PendingInvoiceValidationNotification } from './PendingInvoiceValidationNotification';
import { PendingProcessingNotification } from './PendingProcessingNotification';
import { PendingQualityControlNotification } from './PendingQualityControlNotification';
import { PendingRepairNotification } from './PendingRepairNotification';
import { PendingServiceChoiceNotification } from './PendingServiceChoiceNotification';
import { RequalificationRefusedNotification } from './RequalificationRefusedNotification';
import { ServicesToAssociateNotification } from './ServicesToAssociateNotification';
import { ShipmentArrivedAtPickupPointNotification } from './ShipmentArrivedAtPickupPointNotification';
import { ShipmentIssueArchivedNotification } from './ShipmentIssueArchivedNotification';
import { ShipmentIssueReportedNotification } from './ShipmentIssueReportedNotification';
import { ShipmentIssueResolvedNotification } from './ShipmentIssueResolvedNotification';
import { ShipmentToCreateNotification } from './ShipmentToCreateNotification';

export const Notification = ({ notification }: { notification: TNotification }) => {
  switch (notification.type) {
    case 'analysis_refused':
      return <AnalysisRefusedNotification notification={notification} />;
    case 'article_none_service_choice':
      return <ArticleNoneServiceChoiceNotification notification={notification} />;
    case 'article_repair_issue_reported':
      return <ArticleRepairIssueReportedNotification notification={notification} />;
    case 'article_repair_started':
      return <ArticleRepairStartedNotification notification={notification} />;
    case 'article_status_due_at_manually_updated':
      return <ArticleStatusDueAtManuallyUpdatedNotification notification={notification} />;
    case 'articles_feedback_submitted':
      return <ArticlesFeedbackSubmittedNotification notification={notification} />;
    case 'article_quality_control_ko':
      return <ArticleQualityControlKONotification notification={notification} />;
    case 'client_comment_added':
      return <ClientCommentAddedNotification notification={notification} />;
    case 'comment_added':
      return <CommentAddedNotification notification={notification} />;
    case 'dispatch_proposal_refused':
      return <DispatchProposalRefusedNotification notification={notification} />;
    case 'dispatch_proposal_submitted':
      return <DispatchProposalSubmittedNotification notification={notification} />;
    case 'dispatch_refused':
      return <DispatchRefusedNotification notification={notification} />;
    case 'due_date_alerting':
      return <DueDateAlertingNotification notification={notification} />;
    case 'exchange_canceled':
      return <ExchangeCanceledNotification notification={notification} />;
    case 'exchange_stock_availability_refused':
      return <ExchangeStockAvailabilityRefusedNotification notification={notification} />;
    case 'final_quote_refused':
      return <FinalQuoteRefusedNotification notification={notification} />;
    case 'initial_quote_accepted':
      return <InitialQuoteAcceptedNotification notification={notification} />;
    case 'initial_quote_refused':
      return <InitialQuoteRefusedNotification notification={notification} />;
    case 'invoices_to_validate':
      return <InvoicesToValidateNotification notification={notification} />;
    case 'missing_article_customs':
      return <MissingArticleCustomsNotification notification={notification} />;
    case 'new_client_feedback':
      return <NewClientFeedbackNotification notification={notification} />;
    case 'new_requalification':
      return <NewRequalificationNotification notification={notification} />;
    case 'new_supervisor_assignment':
      return <NewSupervisorAssignmentNotification notification={notification} />;
    case 'new_supervisor_assignment_bulk':
      return <NewSupervisorAssignmentBulkNotification notification={notification} />;
    case 'pending_analysis':
      return <PendingAnalysisNotification notification={notification} />;
    case 'pending_client_contact':
      return <PendingClientContactNotification notification={notification} />;
    case 'pending_client_pickup':
      return <PendingClientPickupNotification notification={notification} />;
    case 'pending_dispatch_acceptation':
      return <PendingDispatchAcceptationNotification notification={notification} />;
    case 'pending_exchange':
      return <PendingExchangeNotification notification={notification} />;
    case 'pending_exchange_stock_availability_confirmation':
      return (
        <PendingExchangeStockAvailabilityConfirmationNotification notification={notification} />
      );
    case 'pending_invoice_validation':
      return <PendingInvoiceValidationNotification notification={notification} />;
    case 'pending_processing':
      return <PendingProcessingNotification notification={notification} />;
    case 'pending_quality_control':
      return <PendingQualityControlNotification notification={notification} />;
    case 'pending_service_choice':
      return <PendingServiceChoiceNotification notification={notification} />;
    case 'pending_repair':
      return <PendingRepairNotification notification={notification} />;
    case 'requalification_refused':
      return <RequalificationRefusedNotification notification={notification} />;
    case 'services_to_associate':
      return <ServicesToAssociateNotification notification={notification} />;
    case 'shipment_arrived_at_pickup_point':
      return <ShipmentArrivedAtPickupPointNotification notification={notification} />;
    case 'shipment_issue_archived':
      return <ShipmentIssueArchivedNotification notification={notification} />;
    case 'shipment_issue_reported':
      return <ShipmentIssueReportedNotification notification={notification} />;
    case 'shipment_issue_resolved':
      return <ShipmentIssueResolvedNotification notification={notification} />;
    case 'shipment_to_create':
      return <ShipmentToCreateNotification notification={notification} />;
    default:
      // Exhaustive check to ensure all notification types are handled
      // eslint-disable-next-line no-case-declarations
      const _exhaustiveCheck: never = notification;

      return _exhaustiveCheck && null;
  }
};
